import { ref, computed } from "vue";

export const headerHeight = computed(() => `${8}dvh`);
